import { definePreset } from "@primeuix/themes";
import Aura from '@primeuix/themes/aura';
import { palette } from '@primeuix/themes';

const MyPrimeNgPreset = definePreset(Aura, {
  primitive: {
    // Custom color palette based on #1B75BB
    dawmtblue: palette('#1B75BB')
  },
  semantic: {
    primary: '{dawmtblue}',
    colorScheme: {
      light: {
        primary: {
          color: '{dawmtblue.600}',
          contrastColor: '#ffffff',
          hoverColor: '{dawmtblue.700}',
          activeColor: '{dawmtblue.800}'
        }
      },
      dark: {
        primary: {
          color: '{dawmtblue.400}',
          contrastColor: '{dawmtblue.950}',
          hoverColor: '{dawmtblue.300}',
          activeColor: '{dawmtblue.200}'
        }
      }
    }
  }
});

export const PrimeNgConfig = {
  theme: {
    preset: MyPrimeNgPreset,
    options: {
      darkModeSelector: '.dark-mode'
    }
  }
};
